import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { Tournament } from 'Src/models/tournament';
import { getTournament } from 'Src/helpers/service/adminSU/tournamentsTable';
import { TournamentCompetitionStructure } from 'Src/components/TournamentCompetitionStructure/TournamentCompetitionStructure';

interface Props { user: AppUser; location: {search:string}; }

export const TournamentCompetitionStructurePage: React.FC<Props> = ({user,location}) => {
  const tournamentId=new URLSearchParams(location.search).get('tournament')||'';
  const [tournament,setTournament]=React.useState<Tournament>();
  const [error,setError]=React.useState('');
  React.useEffect(()=>{let active=true;setError('');getTournament(user,tournamentId).then(value=>{if(active)setTournament(value);}).catch(()=>{if(active)setError('Tournament structure could not be loaded.');});return()=>{active=false;};},[user,tournamentId]);
  if(error)return <div className="tcsPageState is-error">{error}</div>;
  if(!tournament)return <div className="tcsPageState">Loading tournament structure…</div>;
  return <TournamentCompetitionStructure user={user} tournament={tournament} standalone/>;
};
